import AuthService from '@/services/auth'
import { isSessionBlocked } from '@/services/sessionExpiry'

export default ({ router }) => {
    router.beforeEach((to, from, next) => {
        if (isSessionBlocked()) {
            return next()
        }

        if (!AuthService.user()) {
            const loginUrl = AuthService.instance().createLoginUrl()
            return window.location.replace(loginUrl)
        }

        return next()
    })
}
